"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.buildRBSP = void 0;

var bytes = _interopRequireWildcard(require("../../../helpers/byte-helpers"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var NALU =
/*#__PURE__*/
function () {
  function NALU(payload) {
    _classCallCheck(this, NALU);

    this.objType = 'NALU';
    var reader = new bytes.BitReader(payload);
    this.forbidden_bit = reader.readBit();
    this.nal_ref_idc = reader.readBits(2);
    this.nal_unit_type = reader.readBits(5);
    this.payload = payload;
  }

  _createClass(NALU, [{
    key: "rbsp",
    get: function get() {
      return buildRBSP(this.payload);
    }
  }, {
    key: "length",
    get: function get() {
      return this.rbsp.length;
    }
  }]);

  return NALU;
}();

var buildRBSP = function buildRBSP(payload) {
  var result = [];
  var reader = new bytes.BitReader(payload);

  while (!reader.atEnd()) {
    var byte = reader.readBits(8);
    result.push(byte);

    if (bytes.equal(result.slice(-3), [0, 0, 3])) {
      result = result.slice(0, -3);
      reader.rewind(24);
      result.push(reader.readBits(8));
      result.push(reader.readBits(8));
      reader.readBits(8); /// emulation byte

      result.push(reader.readBits(8));
    }
  }

  return result;
};

exports.buildRBSP = buildRBSP;
var _default = NALU;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@krad/plainview/node_modules/@krad/slugline/distribution/parsers/container/ts/nalu.js
// module id = 477
// module chunks = 0